import {useEffect, useRef} from "react"
import { render } from "react-dom"


import "./frontend.css"

const galleryDivToUpdate = document.querySelectorAll(".opc-gallery-block-update-me")

galleryDivToUpdate.forEach(div => {
    const dataRaw = div.querySelector("pre").innerHTML
    const data = JSON.parse(dataRaw)    
    
    const heading = data.heading
    const images = data.gallery
    
    const dataForRendering = {heading, images}
    
    render(<GalleryBlock {...dataForRendering}/>, div)
    div.classList.remove(".opc-gallery-block-update-me")
})

function GalleryBlock(props){
    const galleryHeadingRef = useRef(null)
    useEffect( () => {
        galleryHeadingRef.current.innerHTML = props.heading
        slider()
    }, [])

    return (
    <>
        <h2 ref={galleryHeadingRef}>OUR GALLERY</h2>
        <div className="gallery-container">
            <div className="main-img">
                <img loading="lazy" src={props.images[0].link} alt={props.images[0].alt} />
                <div className="main-img-controls">
                    <i className="fas fa-angle-left"></i>
                    <i className="fas fa-angle-right"></i>
                </div>
            </div> 
            <div className="scroll-imgs">
                {
                    props.images.map( (image, index) => {
                        return (
                            <>
                            {
                            index === 0 ? 
                                (<div className="scroll-img active-image" key={image.id}>
                                    <img src={image.link} alt={image.alt} />
                                </div>) 
                                : 
                                (<div className="scroll-img" key={image.id}>
                                <img src={image.link} alt="" />
                                </div>)
                            }                                
                            </>
                        )
                    })
                }
            </div>
        </div> 
    </>
    )
    
}


// control for gallery images

function slider(){
    const prev = document.querySelector(".fa-angle-left")
    const next = document.querySelector(".fa-angle-right")
    const mainImage = document.querySelector(".main-img img")
    const galleryImageDiv = document.querySelectorAll(".scroll-img")
    const galleryImages = document.querySelectorAll(".scroll-img img")

    let counter = 0

    next.addEventListener("click", () => {
        if(counter < galleryImages.length - 1){
            counter = counter + 1
        } else {
            counter = 0
        }
        mainImage.src = galleryImages[counter].src
        removeActiveImageClass()
        galleryImageDiv[counter].classList.add("active-image")
    })

    prev.addEventListener("click", () => {
        if(counter == 0){
            counter = galleryImages.length - 1
        } else {
            counter = counter - 1
        }
        mainImage.src = galleryImages[counter].src
        removeActiveImageClass()
        galleryImageDiv[counter].classList.add("active-image")
    })

    const removeActiveImageClass = () => {
        galleryImageDiv.forEach( div => {
            div.classList.remove("active-image")
        })
    }

    // display the clicked image

    const sources = Array.from(galleryImages).map( img => {
        return img.src
    })

    galleryImages.forEach( img => {
            img.addEventListener("click", (e) => { 
                counter = sources.indexOf(e.target.src)       
                mainImage.src = e.target.src
                removeActiveImageClass()        
                e.target.parentNode.classList.add("active-image")
        })
    })
}



 